import { WellnessWheelArcProps } from "../types";

export default function LifestyleCategoryArc({
  arcColorFill,
}: WellnessWheelArcProps) {
  return (
    <path
      d="M237.622 184.907A110.26 110.26 0 0 1 138.5 247.553"
      stroke={arcColorFill}
      strokeWidth="50.521"
      strokeLinecap="round"
      fill="none"
      style={{
        strokeDasharray: 1000,
        strokeDashoffset: 1000,
        animation: "drawArc 1s ease-out 1s forwards",
      }}
    />
  );
}
